module.exports = __webpack_public_path__ + "img/icon-auto-exchange.64f8cf40.svg";